import { all, fork, put, takeEvery, call } from 'redux-saga/effects';
import { SagaIterator } from '@redux-saga/core';

// apicore
import { APICore } from '../../helpers/api/apiCore';

import {
    addFaultyReceived_API,
    updFaultyReceived_API,
    addFaultyDecalre_API,
    updFaultyDecalre_API,
    addFaultySent_API,
    updFaultySent_API,
    addFaultyReceivedBack_API,
    updFaultyReceivedBack_API,
} from '../../helpers';

// actions
import { faultyApiResponseSuccess, faultyApiResponseError } from './actions';

// constants
import { FaultyActionTypes } from './constants';

type InvoiceReturnData = {
    payload: {
        id: string;
        entrydate: String;
        accountid: String;
        sales_categoriesid: String;
        reference: String;
        notes: String;
        totalprice: String;
        cashpaid: String;
        subtotal: String;
        netamount: String;
        invoicedetdata: Object;
    };
    type: string;
};
// type UpdInvoiceReturnData = {
//     payload: {
//        id:string;entrydate:string;invoicenumber:string;customerid:string;sales_categoriesid:string;salesmanid:string;reference:string;notes:string;invoicetermsid:string|null;freight:string;shipmentno:string;carrierid:string;totalDiscount:string;totalprice:string;cashreceived:string;subtotal:string;expense:string;invoicetotal:string;custfreight:boolean;custexpense:boolean;name:string;phone:string;address:string;tax:string;taxamount:string;phonecode:string;invoicedetdata:Object

//     };
//     type: string;
// };

const api = new APICore();

function* addFaultyReceived({
    payload: {
        entrydate,
        accountid,
        sales_categoriesid,
        reference,
        notes,
        totalprice,
        cashpaid,
        subtotal,
        netamount,
        invoicedetdata,
    },
}: InvoiceReturnData): SagaIterator {
    try {
        const response = yield call(addFaultyReceived_API, {
            entrydate,
            accountid,
            sales_categoriesid,
            reference,
            notes,
            totalprice,
            cashpaid,
            subtotal,
            netamount,
            invoicedetdata,
        });

        const item = response.data;
        yield put(faultyApiResponseSuccess(FaultyActionTypes.ADD_FAULTY_RECEIVED, item));
    } catch (error: any) {
        yield put(faultyApiResponseError(FaultyActionTypes.ADD_FAULTY_RECEIVED, error));
    }
}
function* addFaultyReceivedBack({
    payload: {
        entrydate,
        accountid,
        sales_categoriesid,
        reference,
        notes,
        totalprice,
        cashpaid,
        subtotal,
        netamount,
        invoicedetdata,
    },
}: InvoiceReturnData): SagaIterator {
    try {
        const response = yield call(addFaultyReceivedBack_API, {
            entrydate,
            accountid,
            sales_categoriesid,
            reference,
            notes,
            totalprice,
            cashpaid,
            subtotal,
            netamount,
            invoicedetdata,
        });

        const item = response.data;
        yield put(faultyApiResponseSuccess(FaultyActionTypes.ADD_FAULTY_RECEIVED_BACK, item));
    } catch (error: any) {
        yield put(faultyApiResponseError(FaultyActionTypes.ADD_FAULTY_RECEIVED_BACK, error));
    }
}
function* updFaultyReceivedBack({
    payload: {
        id,
        entrydate,
        accountid,
        sales_categoriesid,
        reference,
        notes,
        totalprice,
        cashpaid,
        subtotal,
        netamount,
        invoicedetdata,
    },
}: InvoiceReturnData): SagaIterator {
    try {
        const response = yield call(updFaultyReceivedBack_API, {
            id,
            entrydate,
            accountid,
            sales_categoriesid,
            reference,
            notes,
            totalprice,
            cashpaid,
            subtotal,
            netamount,
            invoicedetdata,
        });

        const item = response.data;
        yield put(faultyApiResponseSuccess(FaultyActionTypes.UPD_FAULTY_RECEIVED_BACK, item));
    } catch (error: any) {
        yield put(faultyApiResponseError(FaultyActionTypes.UPD_FAULTY_RECEIVED_BACK, error));
    }
}
function* addFaultySent({
    payload: {
        entrydate,
        accountid,
        sales_categoriesid,
        reference,
        notes,
        totalprice,
        cashpaid,
        subtotal,
        netamount,
        invoicedetdata,
    },
}: InvoiceReturnData): SagaIterator {
    try {
        const response = yield call(addFaultySent_API, {
            entrydate,
            accountid,
            sales_categoriesid,
            reference,
            notes,
            totalprice,
            cashpaid,
            subtotal,
            netamount,
            invoicedetdata,
        });

        const item = response.data;
        yield put(faultyApiResponseSuccess(FaultyActionTypes.ADD_FAULTY_SENT, item));
    } catch (error: any) {
        yield put(faultyApiResponseError(FaultyActionTypes.ADD_FAULTY_SENT, error));
    }
}
function* addFaultyDecalre({ payload: { entrydate, notes, invoicedetdata } }: InvoiceReturnData): SagaIterator {
    try {
        const response = yield call(addFaultyDecalre_API, {
            entrydate,
            notes,
            invoicedetdata,
        });

        const item = response.data;
        yield put(faultyApiResponseSuccess(FaultyActionTypes.ADD_FAULTY_DECLARE, item));
    } catch (error: any) {
        yield put(faultyApiResponseError(FaultyActionTypes.ADD_FAULTY_DECLARE, error));
    }
}
function* updFaultyDeclare({ payload: { id, entrydate, notes, invoicedetdata } }: InvoiceReturnData): SagaIterator {
    try {
        const response = yield call(updFaultyDecalre_API, {
            id,
            entrydate,
            notes,
            invoicedetdata,
        });
        const item = response.data;
        yield put(faultyApiResponseSuccess(FaultyActionTypes.UPD_FAULTY_DECLARE, item));
    } catch (error: any) {
        yield put(faultyApiResponseError(FaultyActionTypes.UPD_FAULTY_DECLARE, error));
    }
}
function* updFaultyReceived({
    payload: {
        id,
        entrydate,
        accountid,
        sales_categoriesid,
        reference,
        notes,
        totalprice,
        cashpaid,
        subtotal,
        netamount,
        invoicedetdata,
    },
}: InvoiceReturnData): SagaIterator {
    try {
        const response = yield call(updFaultyReceived_API, {
            id,
            entrydate,
            accountid,
            sales_categoriesid,
            reference,
            notes,
            totalprice,
            cashpaid,
            subtotal,
            netamount,
            invoicedetdata,
        });

        const item = response.data;
        yield put(faultyApiResponseSuccess(FaultyActionTypes.UPD_FAULTY_RECEIVED, item));
    } catch (error: any) {
        yield put(faultyApiResponseError(FaultyActionTypes.UPD_FAULTY_RECEIVED, error));
    }
}
function* updFaultySent({
    payload: {
        id,
        entrydate,
        accountid,
        sales_categoriesid,
        reference,
        notes,
        totalprice,
        cashpaid,
        subtotal,
        netamount,
        invoicedetdata,
    },
}: InvoiceReturnData): SagaIterator {
    try {
        const response = yield call(updFaultySent_API, {
            id,
            entrydate,
            accountid,
            sales_categoriesid,
            reference,
            notes,
            totalprice,
            cashpaid,
            subtotal,
            netamount,
            invoicedetdata,
        });

        const item = response.data;
        yield put(faultyApiResponseSuccess(FaultyActionTypes.UPD_FAULTY_SENT, item));
    } catch (error: any) {
        yield put(faultyApiResponseError(FaultyActionTypes.UPD_FAULTY_SENT, error));
    }
}

export function* watchAdd(): any {
    yield takeEvery(FaultyActionTypes.ADD_FAULTY_RECEIVED, addFaultyReceived);
    yield takeEvery(FaultyActionTypes.ADD_FAULTY_SENT, addFaultySent);
    yield takeEvery(FaultyActionTypes.UPD_FAULTY_SENT, updFaultySent);
    yield takeEvery(FaultyActionTypes.UPD_FAULTY_RECEIVED_BACK, updFaultyReceivedBack);
    yield takeEvery(FaultyActionTypes.ADD_FAULTY_RECEIVED_BACK, addFaultyReceivedBack);
    yield takeEvery(FaultyActionTypes.UPD_FAULTY_DECLARE, updFaultyDeclare);
    yield takeEvery(FaultyActionTypes.ADD_FAULTY_DECLARE, addFaultyDecalre);
    yield takeEvery(FaultyActionTypes.UPD_FAULTY_RECEIVED, updFaultyReceived);
}

function* salesSaga() {
    yield all([fork(watchAdd)]);
}

export default salesSaga;
